import React from "react";
import {TextField} from "@material-ui/core";
import {Autocomplete, createFilterOptions} from "@material-ui/lab";
import ContextTextArea from "./context_text_area";
import {ClientContextEditor, PresetOption} from "./use_client_context_editor";

const filterPresets = createFilterOptions<PresetOption>();

interface ClientContextFieldsProps {
  editor: ClientContextEditor;
  textPlaceholder: string;
}

const ClientContextFields: React.FC<ClientContextFieldsProps> = ({
  editor,
  textPlaceholder,
}) => {
  return (
    <>
      <Autocomplete
        size="small"
        freeSolo
        options={editor.presets as PresetOption[]}
        value={editor.selectedPreset}
        inputValue={editor.inputValue}
        onInputChange={(_, value) => editor.setInputValue(value)}
        filterOptions={(options, state) => {
          const filtered = filterPresets(options, state);
          const input = state.inputValue.trim();
          const exists = editor.presets.some(preset => preset.name === input);
          if (input !== "" && !exists) {
            filtered.push({inputValue: input, name: `Create "${input}"`});
          }
          return filtered;
        }}
        getOptionLabel={option => {
          if (typeof option === "string") {
            return option;
          }
          if ("inputValue" in option) {
            return option.inputValue;
          }
          return option.name;
        }}
        renderOption={option => option.name}
        onChange={(_, value) => editor.handlePickerChange(value)}
        renderInput={inputParams => (
          <TextField
            {...inputParams}
            label="Client"
            placeholder="Search clients, or type a name to create one"
            variant="outlined"
            error={Boolean(editor.pickerError)}
            helperText={editor.pickerError || undefined}
          />
        )}
        style={{marginBottom: "12px"}}
      />
      <ContextTextArea
        value={editor.editedContext}
        onChange={editor.setEditedContext}
        placeholder={textPlaceholder}
      />
    </>
  );
};

export default ClientContextFields;
